export const environment = {
    production: true,
    apiUrl: 'https://patriacura.de/api/backend/api/v1/',
};
